module.exports = __webpack_public_path__ + "media/images/iconFirmware-3faeabfa.png";